module.exports = __webpack_public_path__ + "img/leftList2_active.3c3c5cd9.svg";